export enum CATERING_SCHEDULER_ACTIONS {
  CATERING_PACKAGE_START = 'catering_package_start',
  CATERING_PACKAGE_END = 'catering_package_end',
  CATERING_KDS = 'catering_kds',
  PROCESS_ORDER = 'process_order',
  CATERING_KDS_V2 = 'catering_kds_v2',
  CATERING_PAYMENT_INSTALLMENT_DUE = 'catering_payment_installment_due',
}
export enum CtrOrderItemCategory {
  FOOD = 'Food',
  NON_FOOD = 'Non-Food',
}

export enum CtrOrderItemFulfillmentSource {
  SINGLE_ITEM = 'single_item',
  COMPLETE_ORDER = 'complete_order',
}
